export default __webpack_public_path__ + "static/blakes-6a323ddf0dc4eddbe1a1c2b73274fbde.png";